export default function Unauthorized() {
  return (
    <div className="home-container">
      <h2 style={{ color: "white", margin: "10%" }}>You don't have access to the PCI Safety Dashboard.</h2>
    </div>
  )
}
